import { render, staticRenderFns } from "./CalendarEventPopover.vue?vue&type=template&id=d0d4d6c4&scoped=true&"
import script from "./CalendarEventPopover.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CalendarEventPopover.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CalendarEventPopover.vue?vue&type=style&index=0&id=d0d4d6c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d4d6c4",
  null
  
)

export default component.exports